import {LEAGUES} from '../../constants/leagues';
import {PLAYER_BONUS_LABELS, PLAYER_BONUS_TYPES} from '../../configs/playerBonus';
import {getPlayerBonusValues} from '../gameState/getPlayerBonusValues';
import {getPlayerBonusLines} from '../players/getPlayerBonusLines';
import {AI_PLAYER_TITLE} from '../../configs/aiMatch';
import {getBotSupplySizeBonusLines} from './getBotSupplySizeBonusLines';
import {getBotDiceBonusLines} from './getBotDiceBonusLines';
import {getBotD6MinRoll} from '../dice/getBotD6MinRoll';

// Название лиги в мужском роде — под слово «Бот». В конфиге лиг название
// женское («Золотая лига»), поэтому отдельным списком. Общий с разделом
// правил «Боты»
export const LEAGUE_ADJECTIVES = {
  [LEAGUES.BRONZE]: 'Бронзовый',
  [LEAGUES.SILVER]: 'Серебряный',
  [LEAGUES.GOLD]: 'Золотой',
  [LEAGUES.DIAMOND]: 'Алмазный',
  [LEAGUES.RUBY]: 'Рубиновый',
  [LEAGUES.GOD]: 'Божественный',
};

/**
 * Подпись бота для подсказки: лига или уровень бонуса и расшифровка бонуса,
 * теми же строками, что и подсказка выбора бонуса в локальной игре (экономика
 * и очки победы к доходу — фиксированные и за каждый город, у старых матчей —
 * числа, которые тогда действовали), у ботов старших лиг — еще и прибавка к росту
 * отрядов, а у бота, которому уровень бонуса подкручивает кости («божество»),
 * — и строка про кость урона.
 *
 * Числа берутся зафиксированными на старте матча (см. getPlayerBonusValues),
 * поэтому подсказка в реплее показывает то, что бот получил тогда, а не то, что
 * дал бы нынешний конфиг.
 *
 * ИИ-игрок промо-матча — не бот: у него своя подпись (какая модель играет), а
 * строк бонуса нет — он играет на общих условиях с людьми.
 */
export const getVisibleBotTitle = (player) => {
  if (player && player.isAi) {
    return AI_PLAYER_TITLE;
  }

  const adjective = LEAGUE_ADJECTIVES[player && player.leagueId];
  const title = adjective ? `${adjective} Бот` : 'Бот';
  const lines = [
    ...getPlayerBonusLines(getPlayerBonusValues(player)),
    // Прибавка к росту отрядов у ботов старших лиг — тоже зафиксированная на
    // старте (см. configs/botLeagueSupplyGrowth)
    ...getBotSupplySizeBonusLines(player && player.botSupplySizeBonus),
    // Кости — только боту, помеченному ботом для всех (явному и локальному):
    // getBotD6MinRoll сам это проверяет и берет те же зафиксированные числа
    ...getBotDiceBonusLines(getBotD6MinRoll(player)),
  ];

  // У бота локальной партии лиги нет, зато уровень бонуса ему выбирал сам
  // игрок — называем этот уровень словом. Иначе в старых записях «нет» и
  // прежний SMALL было бы не различить: иконка у них одна на двоих (см.
  // LOCAL_BOT_LEAGUE_BY_BONUS)
  if (player && player.isLocalBot) {
    const bonusLabel = PLAYER_BONUS_LABELS[player.bonus] || PLAYER_BONUS_LABELS[PLAYER_BONUS_TYPES.NONE];
    lines.unshift(`Бонус: ${bonusLabel}`);
  }

  return lines.length > 0 ? `${title}\n${lines.join('\n')}` : title;
};
